import axios from 'axios';
import LoginService from '../acesso/login.service'

const API_URL = process.env.VUE_APP_BASE_URL + '/api/gpi/';

class GpiService {
  constructor() {
    LoginService.currentUser.subscribe(data => {
      this.headers = {
        'Content-Type': 'application/json',
        'authorization': 'Bearer ' + (data ? data.token : '')
      };
    });
  }

  atualizarVencimento(idCliente, idUsuario, idCalculoOrigem, idCalculoParcelado, dataVencimento) {
    return axios.post(
      API_URL + 'atualizarVencimento?idCliente=' + idCliente + '&idUsuario=' + idUsuario + '&idCalculoOrigem=' + idCalculoOrigem + '&idCalculoParcelado=' + idCalculoParcelado + '&dataVencimento=' + dataVencimento,
      null,
      { headers: this.headers },
    );
  }

  imprimir(idCliente, idCalculoParcelado) {
    return axios({
      url: API_URL + "imprimirDam?idCliente=" + idCliente + "&idCalculoParcelado=" + idCalculoParcelado,
      method: "POST",
      responseType: "blob",
      data: null,
      headers: this.headers
    }).then(response => {
      var fileURL = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );
      window.open(fileURL);
      console.log(response.data);
    });
  }

  imprimirTaxa(idCliente, ano, numero) {
    return axios({
      url: API_URL + "imprimirTaxa?idCliente=" + idCliente + "&ano=" + ano + "&numero=" + numero,
      method: "POST",
      responseType: "blob",
      data: null,
      headers: this.headers
    }).then(response => {
      var fileURL = window.URL.createObjectURL(
        new Blob([response.data], { type: "application/pdf" })
      );
      window.open(fileURL);
      console.log(response.data);
    });
  }

  imprimirNotificacao(idCliente, idCalculoParcelado) {
    return axios({
      url: API_URL + "imprimirNotificacao?idCliente=" + idCliente + "&idCalculoParcelado=" + idCalculoParcelado,
      method: "POST",
      responseType: "blob",
      data: null,
      headers: this.headers
    }).then(async response => {      
      if (response.status != 200) {
        const text = await response.data.text();
        throw new Error(text);
      } else {
        const fileURL = window.URL.createObjectURL(new Blob([response.data], { type: "application/pdf" }));
        window.open(fileURL);
        return response.data;
      }
    });
  }
}

export default new GpiService();